// src/layout/sidebar.tsx

import React from "react";
import { NavLink } from "react-router-dom";
import Chip from '@mui/material/Chip';
import { useVersionContext } from "../context/VersionContext";

const Sidebar = () => {
  const { currentVersion } = useVersionContext();

  // Get components from version registry
  const components = currentVersion.components;

  // Filter available components for this version
  const availableComponents = components.filter(
    (comp) => comp.availableIn.includes(currentVersion.id)
  );

  return (
    <div>
      <div className="sidebar scroll-on-hover">
        <h6 className="m-t-10 m-b-0 m-l-20">Components</h6>
        <ul id="dynamic-tabs">
          {availableComponents.map((component) => (
            <li key={component.path}>
              <NavLink
                to={`/components/${component.path}`}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                {component.name}
                {component.deprecated?.includes(currentVersion.id) && (
                  <Chip
                    label="Deprecated"
                    color="warning"
                    size="small"
                    sx={{ marginLeft: 1 }}
                  />
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
